module.exports = __webpack_public_path__ + "img/generacion-energia.d9fffbc9.webp";